/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-one-expression-per-line */
import PropTypes from 'prop-types';
import React from 'react';
import { signUp } from '../../utils/contentProvider/function';

export const PricingTable = ({
  views,
  currentTab,
  // productTabs,
  toggleSignup,
  pricingData,
  togglePurchaseModal,
  websitePlan,
  setWebsitePlan,
  getProPlanValue,
  getTeamPlanValue,
  getStarterPlanValue = () => {},
  // offersPage,
  enterpriseData,
  // setCurrentTab,
}) => (
  <section className="pricing-table" id="pricing-table">
    <div
      style={{
        marginInline: '48px',
      }}>
      {/* <h2 className="center">Explore the top features</h2> */}

      <div className="pricing-table-wrapper">
        <div className="flex sticky hidden-mob ">
          <div className="table-head toggle-table-head ">
            {/* {!offersPage && (
              <div className="views-toggle">
                <span>Individual</span>
                <label htmlFor="pricing-toggle" className="switch">
                  <input
                    id="pricing-toggle"
                    type="checkbox"
                    checked={currentTab === views.businesses}
                    onChange={
                      currentTab === views.businesses
                        ? () => setCurrentTab(views.individual)
                        : () => setCurrentTab(views.businesses)
                    }
                  />
                  <span className="slider round"></span>
                </label>
                <span>Businesses</span>
              </div>
            )} */}

            <div className="pricing-toggle-container gap-4 justify-content-between">
              <div className="pricing-toggle-main">
                <button
                  type="button"
                  className={websitePlan === 'monthly' ? 'active-price' : ''}
                  onClick={() => setWebsitePlan('monthly')}>
                  Monthly
                </button>
                <button
                  type="button"
                  className={websitePlan === 'yearly' ? 'active-price' : ''}
                  onClick={() => setWebsitePlan('yearly')}>
                  Yearly
                </button>
              </div>
            </div>
          </div>
          <div className="table-content">
            <div className="flex">
              <div className="single-plan three-col">
                <div className="plan-head">
                  <h4>Starter</h4>

                  <p className="month">
                    <span>{`$${getStarterPlanValue()}`}</span>
                  </p>

                  <p className="small-price-desc">
                    <>/month/user&nbsp;</>
                    {websitePlan === 'yearly' ? 'billed yearly' : ''}
                  </p>

                  <button
                    type="button"
                    onClick={() => signUp(toggleSignup)}
                    className="button button-white blue-text"
                    id={`free-get-started-${enterpriseData.btnId}-pricing-table`}>
                    Get Started
                  </button>
                </div>
              </div>

              <div className="single-plan three-col">
                <div className="plan-head">
                  <h4>Pro</h4>

                  <p className="month">
                    <>
                      <span>{`$${getProPlanValue()}`}</span>
                    </>
                  </p>
                  <p className="small-price-desc">
                    <>/month/user&nbsp;</>
                    {websitePlan === 'yearly' ? 'billed yearly' : ''}
                  </p>

                  {currentTab === views.businesses ? (
                    <button
                      type="button"
                      onClick={() => signUp(toggleSignup)}
                      className="button"
                      id={`pro-get-started-${enterpriseData.btnId}-pricing-table`}>
                      Get Started
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={togglePurchaseModal(0)}
                      className="button button-white blue-text"
                      id="pricing-table-button-standard-2">
                      Contact Sales
                    </button>
                  )}
                </div>
              </div>
              <div className="single-plan three-col">
                <div className="plan-head">
                  <h4>Business</h4>

                  <p className="month">
                    <span>{`$${getTeamPlanValue()}`}</span>
                  </p>
                  <p className="small-price-desc">
                    <>/month/user&nbsp;</>
                    {websitePlan === 'yearly' ? 'billed yearly' : ''}
                  </p>

                  <button
                    type="button"
                    onClick={() => signUp(toggleSignup)}
                    className="button button-white blue-text"
                    id={`team-get-started-${enterpriseData.btnId}-pricing-table`}>
                    Get Started
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="plan-detail">
          {pricingData.map(({ headingType, heading, id, data, desc }) => (
            <div
              className={`single-detail ${headingType ? 'grey-light' : ''}`}
              key={id}>
              <div className="flex flex-wrap">
                <div className="table-head">
                  {headingType ? (
                    <h3>{headingType}</h3>
                  ) : (
                    <h4>
                      {heading}

                      <span className="pop-info">
                        <svg width="15px" viewBox="0 0 7.6 7.6">
                          <path
                            d="M7.6 3.8c0 2.1-1.7 3.8-3.8 3.8S0 5.9 0 3.8C0 1.7 1.7 0 3.8 0s3.8 1.7 3.8 3.8zm-7.1 0C.5 5.6 2 7.1 3.8 7.1c1.8 0 3.3-1.5 3.3-3.3C7.1 2 5.6.5 3.8.5 2 .5.5 2 .5 3.8zm2.9 1.5V3.4h-.2c-.1 0-.2-.1-.2-.2v-.1c0-.1.1-.2.2-.2H4c.1 0 .2.1.2.2v2.1h.2c.1 0 .2.1.2.2v.1c0 .1-.1.2-.2.2H3.2c-.1 0-.2-.1-.2-.2v-.1c0-.1.1-.2.2-.2h.2zm.9-3.2c0 .3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5z"
                            fill="#555"
                          />
                        </svg>
                        <span className="info-text">{desc}</span>
                      </span>
                    </h4>
                  )}
                </div>
                <div className="table-content">
                  <div className="flex">
                    <div className="single-plan three-col">
                      {headingType ? '' : <p className="visible-mob">Free</p>}
                      {currentTab === views.businesses ? data.free : data.pro}
                    </div>
                    <div className="single-plan three-col">
                      {headingType ? (
                        ''
                      ) : (
                        <p className="visible-mob">Standard</p>
                      )}
                      {currentTab === views.businesses ? data.pro : data.team}
                    </div>
                    <div
                      className={`single-plan three-col ${
                        headingType ? '' : ''
                      }`}>
                      {headingType ? '' : <p className="visible-mob">Pro</p>}
                      {currentTab === views.businesses
                        ? data.team
                        : data.enterprise}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={() => signUp(toggleSignup)}
        className="button visible-mob">
        Get Started
      </button>

      <div className="flex-row">
        <div className="col-md col-10 offset-1">
          <div className="enterprise-price-wrapper">
            <div className="flex-row align-items-center">
              <div className="col col-8">
                <div className="enterprise-price-desc">
                  <h3>Are you an enterprise?</h3>

                  <div className="flex">
                    <img src="/assets/img/enterprise.svg" alt="Enterprise" />

                    <p>{enterpriseData.content}</p>
                  </div>
                </div>
              </div>

              <div className="col col-4">
                <div className="enterprise-price">
                  <h4>Enterprise Plan</h4>
                  <h3>
                    Custom
                    <span>/month billed annually</span>
                  </h3>

                  <button
                    type="button"
                    onClick={togglePurchaseModal(0)}
                    id={`enterprise-talk-to-sales-${enterpriseData.btnId}`}
                    className="button">
                    Talk to sales
                  </button>

                  <p>{enterpriseData.subtext}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

PricingTable.propTypes = {
  views: PropTypes.object,
  currentTab: PropTypes.number,
  // productTabs: PropTypes.number,
  toggleSignup: PropTypes.any,
  pricingData: PropTypes.array,
  // proPlan: PropTypes.object,
  // standardPlan: PropTypes.object,
  // teamPlan: PropTypes.object,
  togglePurchaseModal: PropTypes.func,
  websitePlan: PropTypes.string,
  setWebsitePlan: PropTypes.func,
  // isWebsiteFeedbackPage: PropTypes.bool,
  enterpriseData: PropTypes.object,
  getProPlanValue: PropTypes.func,
  getStarterPlanValue: PropTypes.func,
  // getStandardPlanValue: PropTypes.func,
  getTeamPlanValue: PropTypes.func,
  // offersPage: PropTypes.bool,
  // setCurrentTab: PropTypes.func,
};
